module.exports = __webpack_public_path__ + "static/img/hitbox-button.0ece8638.png";